import { IBasePreferenceItem } from '@/creditflowresearch/application/hooks/userPreferences/helpers';
import BadgeButton from '@/creditflowresearch/ui/common/components/molecules/BadgeButton';
import {
  LockedPreferenceControl,
} from '@/creditflowresearch/ui/common/components/molecules/LockedFeaturePopup';

interface IPreferenceBadgeButtonProps {
  item: IBasePreferenceItem,
  isFetching: boolean,
  onClick: (item: IBasePreferenceItem) => void,
  isDisabled?: boolean,
  isActive?: boolean,
  isMobile?: boolean,
}

const PreferenceBadgeButton = ({
  item,
  isFetching,
  onClick,
  isActive = false,
  isDisabled = false,
  isMobile = false,
}: IPreferenceBadgeButtonProps) => {
  const abbreviation = item.getEntity()?.getAbbreviation() ?? '';

  const badgeButton = (
    <BadgeButton<IBasePreferenceItem>
      value={ item }
      label={ abbreviation }
      dataTest={ abbreviation }
      onClick={ onClick }
      isActive={ isActive }
      isDisabled={ isDisabled }
      isLoading={ isFetching }
      isMobile={ isMobile }
    />
  );

  return (
    <LockedPreferenceControl isLocked={ isDisabled } items={ [item] }>
      { badgeButton }
    </LockedPreferenceControl>
  );
};

export default PreferenceBadgeButton;
